import "reflect-metadata";
import {inject, injectable} from "inversify";
import {InternalChatRepository} from "@dropDesk/domain/repositories/internal_chat/internal_chat.repository";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";

@injectable()
export class GetUsersFromCacheUseCase {
    private _repository: InternalChatRepository;

    constructor(@inject(InternalChatRepository) repository: InternalChatRepository) {
        this._repository = repository;
    }

    public call(ids: string[]): Promise<UserEntity[]> {
        return this._repository.getUsersFromCache(ids);
    }
}
